import { render, staticRenderFns } from "./addInsurer.vue?vue&type=template&id=7b764e35&scoped=true"
import script from "./addInsurer.vue?vue&type=script&lang=js"
export * from "./addInsurer.vue?vue&type=script&lang=js"
import style0 from "./addInsurer.vue?vue&type=style&index=0&id=7b764e35&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b764e35",
  null
  
)

export default component.exports